import { useFetchCategoriesPreview } from '@entities/Categories'

import type { BlockProps } from '@features/main-page-builder/model/blockRegistry'
import styles from '@features/main-page-builder/ui/styles.module.scss'


import CategoriesPreview from '@widgets/categories-preview/CategoriesPreview'

import { IMAGE_SIZES } from '@shared/contants'

type CategoryBlockPayload = {
  id: string;
  name: string;
  order: number;
  previewSize: 'usual' | 'double' | 'big';
}

export default function CategoriesBlock ({ block: _block, payload, shopId }: BlockProps) {
  const categoryIds = payload ? (payload.categories as CategoryBlockPayload[]).map((category: CategoryBlockPayload) => category.id) : []

  const { categories: categoriesData, loading } = useFetchCategoriesPreview({
    shopId,
    ids: categoryIds.length > 0 ? categoryIds : undefined,
    style: IMAGE_SIZES.TABLET
  })

  const categories = categoriesData ? categoriesData.map(category => {
    const typedPayload = payload?.categories as CategoryBlockPayload[]
    const blockCategory = typedPayload.find((cat: CategoryBlockPayload) => cat.id === category?.id)
    return {
      ...category,
      name: blockCategory?.name ?? category?.name,
      preview_size: blockCategory?.previewSize ?? 'usual',
      order: blockCategory?.order ?? 0
    }
  }).sort((a, b) => a.order - b.order) : []

  return (
    <div className={styles.root__categories}>
      <CategoriesPreview
        categories={categories}
        loading={loading}
      />
    </div>
  )
}
